import styled from 'styled-components';

export const StyledTitleWrapper = styled.div`
  margin-bottom: ${({ theme }): string => theme.spacers!.spacer05};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const Title = styled.div`
  font-family: InspireTWDC;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
`;

export const StyledSubTitle = styled.div`
  font-family: InspireTWDC;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 21px;
  color: ${({ theme }): string => theme.admanColors!.gray.dark.bg3[0]};
`;
